import CmnBtnContainer from '../layout/components/CmnBtnContainer'
import HomeFeatures from "../layout/components/HomeFeatures";

const Home = () => {
  return (
    <>
        <div style={{ backgroundColor : "#F1F1EC"}} className="cmn-page-container">
            <div className="page-content-wrapper">
                <div className="content">
                    <p>Efficient Timesheet Software for Streamlined Management</p>
                    <p id='home-page-sub-content'>Our timesheet software simplifies time tracking, streamlining payroll and boosting productivity with real-time data and customizable reports.</p>
                    <CmnBtnContainer/>
                </div>
                <div id="home-page-img-container">
                    <div id="home-page-img-wrapper">
                        <img src="/svg/home-page-img.svg" width="100%" height="100%" alt="solution home page" />
                    </div>
                    <div className='circle' id='crcl1'></div>
                    <div className='circle' id='crcl2'></div>
                </div>
            </div>
            <div id='home-page-sub-ft'>
                <h1 style={{color : "white", alignSelf : "start"}}>Why Choose Celaeno Timesheet?</h1>
                <p id="home-page-heading">Unlike other time tracking solutions, Celaeno Timesheet is designed with flexibility, automation, and user-friendly features in mind. Here’s why businesses and freelancers love it.</p>
                <div id='home-page-sub-ft-container'>
                    <div className='sub-ft-wrapper'>
                        <h3>Automated Time Tracking:</h3>
                        <p>Capture work hours without manual input.</p>
                    </div>
                    <div className='sub-ft-wrapper'>
                        <h3>Seamless Integrations:</h3>
                        <p>Sync with invoicing, payroll, and project management tools.</p>
                    </div>
                    <div className='sub-ft-wrapper'>
                        <h3>Customizable Workflows:</h3>
                        <p>Adapt time tracking to your business needs.</p>
                    </div>
                    <div className='sub-ft-wrapper'>
                        <h3>Real-Time Sync:</h3>
                        <p>Keep teams aligned with live time tracking.</p>
                    </div>
                </div>
            </div>
            {/* <section>
                <div class="main-div">
                    <div class="services">Features</div>
                    <img src="dummy.svg" alt=""/>
                    <div class="btn-div">
                        <button class="btn" onclick="showContent('goutContent', this)">Manage Hours</button>
                        <button class="btn" onclick="showContent('otherContent1', this)">Reporting & Analytics</button>
                        <button class="btn" onclick="showContent('otherContent2', this)">Payroll Integration</button>
                        <button class="btn" onclick="showContent('otherContent3', this)">Overtime Calculation</button>
                    </div>

                    <div class="chat-bubble">
                        <div id="goutContent" class="content">
                            <div class="flex-div-feature">
                                <div class="left-div-feature">
                                    <h1>Record and Manage Your Work Hours Effectively</h1>
                                    <p>Our Time Tracking feature allows employees to accurately log their daily work hours,
                                        including precise start and end times, breaks taken, and total hours worked. This
                                        comprehensive tracking ensures accurate calculations for payroll and compliance with
                                        labor regulations, helping organizations adhere to legal standards and streamline their
                                        operations.</p>
                                    <ul>
                                        <li>Track daily work hours with detailed start and end time entries for each day.</li>
                                        <li>Automatically record breaks and calculate total hours worked to minimize errors.
                                        </li>
                                        <li>Generate detailed reports to assist with accurate payroll processing and ensure
                                            compliance with employment laws.</li>
                                        <li>Seamlessly integrate with labor law regulations to ensure that all tracking meets
                                            legal requirements and organizational standards.</li>
                                    </ul>

                                </div>
                                <div class="right-div-feature">
                                    <img src="/images/1.png" alt="dsd" />
                                </div>
                            </div>
                        </div>

                        <div id="otherContent1" class="content">
                            <div class="flex-div-feature">
                                <div class="left-div-feature">
                                    <h1>Flexible Reporting and Analytics</h1>
                                    <p>Gain valuable insights with our flexible reporting and analytics tools. The timesheet
                                        feature includes customizable reports that provide a clear view of hours worked, project
                                        progress, and employee productivity. Users can generate daily, weekly, or monthly
                                        reports to make informed decisions and optimize workflow.</p>
                                    <ul>
                                        <li>Access highly customizable reports to track detailed hours worked and analyze the
                                            progress of various projects, tailored to meet your specific reporting needs.</li>
                                        <li>Monitor employee productivity with in-depth reporting options that provide a
                                            comprehensive view of performance trends and areas for improvement.</li>
                                        <li>Generate and review reports on a daily, weekly, or monthly basis, allowing for
                                            flexible scheduling and better alignment with your reporting requirements.</li>
                                        <li>Utilize advanced analytics to optimize workflow, streamline operations, and make
                                            data-driven decisions that enhance overall organizational efficiency.</li>
                                    </ul>
                                </div>
                                <div class="right-div-feature">
                                    <img src="1.png" alt="dsd" />
                                </div>
                            </div>
                        </div>

                        <div id="otherContent2" class="content">
                            <div class="flex-div-feature">
                                <div class="left-div-feature">
                                    <h1>Seamless Integration with Payroll Systems</h1>
                                    <p>Integrate your timesheet data effortlessly with your payroll system. Our feature ensures
                                        that all recorded hours are accurately transferred to your payroll software, reducing
                                        manual data entry and minimizing errors. This integration streamlines payroll processing
                                        and ensures timely and accurate payments.</p>
                                    <ul>
                                        <li>Effortlessly integrate timesheet data with your payroll system for smooth data
                                            transfer and minimal manual entry.</li>
                                        <li>Reduce errors by ensuring accurate and automatic transfer of recorded hours to
                                            payroll software.</li>
                                        <li>Streamline payroll processing to enhance efficiency and ensure timely, accurate
                                            payments to employees.</li>
                                        <li>Minimize manual data entry and eliminate potential discrepancies for a more reliable
                                            payroll system.</li>
                                    </ul>
                                </div>
                                <div class="right-div-feature">
                                    <img src="1.png" alt="Seamless Integration" />
                                </div>
                            </div>

                        </div>
                        <div id="otherContent3" class="content">
                            <div class="flex-div-feature">
                                <div class="left-div-feature">
                                    <h1>Automated Overtime Calculation</h1>
                                    <p>Our time tracking system includes an automated overtime calculation feature that
                                        simplifies the process of tracking and managing overtime hours. This feature
                                        automatically calculates overtime pay based on your company’s specific rules and rates,
                                        ensuring accurate compensation and compliance with labor laws.</p>
                                    <ul>
                                        <li>Automatically calculate overtime hours based on pre-defined rules and rates to
                                            ensure accurate compensation.</li>
                                        <li>Reduce manual calculations and potential errors with automated overtime tracking.
                                        </li>
                                        <li>Ensure compliance with labor laws by adhering to company-specific overtime policies
                                            and regulations.</li>
                                        <li>Streamline payroll processes with accurate overtime data integrated into your
                                            overall time tracking system.</li>
                                    </ul>
                                </div>
                                <div class="right-div-feature">
                                    <img src="1.png" alt="Automated Overtime Calculation" />
                                </div>
                            </div>


                        </div>
                        <div id="defaultContent" class="content default-content">
                            <div class="flex-div-feature-adv">
                                <div class="left-div-feature-adv">
                                    <img src="feature.svg" alt="" />
                                    <h1>Explore Our Features for the Best Experience</h1>
                                    <p>Discover how our advanced tools can enhance your workflow. By exploring all the features
                                        we offer, you’ll unlock new ways to improve efficiency, streamline tasks, and make the
                                        most out of every workday. Dive in and experience the full power of our timesheet
                                        software.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <HomeFeatures/>

        </div>
    </>
  )
}

export default Home
